import { post } from 'common/apiClient';

export type SourcePayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  TypeofApplication?: string;
  SecretKey?: string;
  CreatedOn?: string;
  IsActive?: string;
  CreatedBy?: any;
  isDeleted?: string;
  SoftCell?: string;
  LoanTypes?: string;
  isSearch?: boolean;
  updateIsActive?: boolean;
  SourceId?: string;
  userId?: number;
};
export type SourceDownloadPayload = {
  isExtract?: boolean;
  Username?: string;
  SourceApplicationName?: string;
  TypeofApplication?: string;
  SecretKey?: string;
  CreatedOn?: string;
  IsActive?: string;
  CreatedBy?: any;
  isDeleted?: string;
  SoftCell?: string;
  LoanTypes?: string;
  isSearch?: boolean;
  updateIsActive?: boolean;
  SourceId?: string;
  userId?: number;
};

export type SearchSourcePayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  SourceId: string;
  TypeofApplication?: string;
  SecretKey?: string;
  CreatedOn?: string;
  IsActive?: string;
  CreatedBy?: any;
  isDeleted?: string;
  SoftCell?: string;
  isSearch?: boolean;
};

export type updateSourcePayload = {
  SourceId?: string;
  SourceApplicationName?: string;
  TypeOfApplication?: string;
  SecretKey?: string;
  CreatedOn?: string;
  pageSize?: any;
  pageNo?: any;
  Username?: any;
  isActive?: boolean;
  CreatedBy?: string | undefined;
  isDeleted?: string;
  softCell?: string;
  message?: string;
  updateIsActive?: boolean;
  loanTypes?: string[] | string;
  userId?: number;
};

export type LoanTypePayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  FundAccMapID?: string;
  LoanType?: string;
  PaymentPurpose?: string;
  ChargesBearBy?: string;
  MerchantID?: string;
  FundingAccount?: string;
  ReceiptService?: string;
  IsActive?: string;
  CreatedOn?: string;
  CreatedBy?: string;
  IsDeleted?: string;
  RazorPayKey?: string;
  RazorSecret?: string;
  PaymentPurposeList?: [];
};

export type AddLoanTypePayload = {
  NewLoanType?: String;
  MappingLoanType?: string;
};

export type AddSourcePayload = {
  SourceId?: string;
  SourceApplicationName?: string;
  TypeOfApplication?: string;
  SecretKey?: string;
  CreatedOn?: string;
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: any;
  isActive?: string;
  CreatedBy?: any;
  isDeleted?: string;
  SoftCell?: string;
  loanTypes?: string[] | string;
  userId?: number;
};

export type DeleteSourcePayload = {
  SourceApplicationName: string;
  SourceId?: string;
};

export type ActivateSourcePayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  TypeofApplication?: string;
  SourceId: string;
  SecretKey?: string;
  CreatedOn?: string;
  IsActive?: string;
  CreatedBy?: any;
  isDeleted?: string;
  SoftCell?: string;
  isSearch?: boolean;
  updateIsActive?: boolean;
};

export type DeleteLoanTypePayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  FundAccMapID?: string;
  LoanType?: string;
  PaymentPurposeList?: [];
};

export type UserFilter = {
  partnerId?: any;
  roleId?: any;
  name?: any;
  isActive?: any;
  pageNo?: any;
  isExtract?: boolean;
  updatedBy?: any;
};

export type SourcePagedResponse = {
  data: SourcePagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type LoanTypePagedResponse = {
  data: LoanTypePagedList;
  message: string;
  responseCode: string;
};

export type SourcePagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: SourceListData[];
};

export type SourceSearchPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: SourceSearchData[];
};

export type UserPagedResponse = {
  data: UserPagedList;
  message: string;
  responseCode: string;
};

export type SearchDetails = {
  sourceSearchList?: JSX.Element;
  key?: React.Key;
  SourceApplicationName: string | undefined;
  TypeOfApplication: string | undefined;
  isActive: string | undefined;
};

export type LoanTypePagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: LoanTypeData[];
};

export type UserPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: User[];
};

export type User = {
  userId?: number;
  name?: string;
  username?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  emailID?: string;
  departmentId?: string;
  roleName?: string;
  isActive?: string;
  isDeleted?: string;
  roleId?: number;
  sourceId?: string;
  createdBy?: string;
  createdOn?: string;
  userName?: string;
  SourceApplicationName?: string;
  IsExtract?: boolean;
  currentPassword?: string;
  confirmPassword?: string;
  message?: string;
};

export type SourceListData = {
  SourceApplicationName: any;
  TypeOfApplication: any;
  SecretKey: any;
  key: React.Key;
  sourceId?: string;
  sourceApplicationName?: string;
  typeOfApplication?: string;
  secretKey?: string;
  createdOn?: any;
  pageSize?: any;
  pageNo?: any;
  username?: string;
  isActive?: boolean;
  createdBy?: string | undefined;
  isDeleted?: string;
  softCell?: string;
  message?: string;
  updateIsActive?: boolean;
  LoanTypes?: string;
  CreatedDate?: string;
};

export type SourceSearchData = {
  sourceId?: string;
  sourceApplicationName?: string;
  typeofApplication?: string;
  secretKey?: string;
  createdOn?: string;
  pageSize?: any;
  pageNo?: any;
  username?: string;
  active?: boolean;
  createdBy?: string | undefined;
  isDeleted?: string;
  softCell?: string;
  message?: string;
  updateIsActive?: boolean;
  LoanTypes?: string;
};

export type LoanTypeData = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  SourceApplicationName?: string;
  FundAccMapID?: string;
  LoanType?: string;
  PaymentPurpose?: string;
  ChargesBearBy?: string;
  MerchantID?: string;
  FundingAccount?: string;
  ReceiptService?: string;
  IsActive?: string;
  CreatedOn?: string;
  CreatedBy?: string;
  IsDeleted?: string;
  RazorPayKey?: string;
  RazorSecret?: string;
  PaymentPurposeList?: any;
};

export type FundAccountFilter = {
  merchantId?: string;
  fundingAccount?: string;
  paymentPurpose?: string;
  loanType?: string;
  receiptService?: string;
  sourceId?: string;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
  sortColumn?: string;
};

export type FundAccountPagedResponse = {
  data: FundAccountPagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type FundAccountPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: FundAccountPayload[];
};

export type FundAccountPayload = {
  FundAccMapID?: string;
  LoanType?: string;
  PaymentPurpose?: string;
  ChargesBearBy?: string;
  MerchantID?: string;
  FundingAccount?: string;
  ReceiptService?: string;
  RazorPayKey?: string;
  RazorSecret?: string;
  SourceApplicationName?: string;
  SourceId?: string;
  Action?: boolean;
  isActive?: boolean;
  CreatedOn?: string;
};

export type FundAccountUpdatePagedResponse = {
  data: FundAccountUpdatePagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type FundAccountUpdatePagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: FundAccountUpdatePayload[];
};

export type FundAccountUpdatePayload = {
  fundAccMapId?: number;
  loanType?: string;
  paymentPurpose?: string;
  chargesBearBy?: string;
  receiptService?: string;
  merchantId?: string;
  fundingAccount?: string;
  sourceApplicationName?: string;
  sourceId?: string;
  razorPayKey?: string;
  razorPaySecret?: string;
  createdOn?: string;
  createdBy?: string;
  isActive?: boolean;
  deleted?: boolean;
};

export type SelectPayload = {
  sKey?: string;
  settingId?: number;
  sVlue?: string;
  environment?: string;
  sText?: string;
};

export type SelectResponse = {
  data: SelectList[];
};

export type SelectList = {
  sKey?: string;
  sVlue?: string;
  sText?: string;
};

export type MstRequest = {
  userName?: string;
  roleId?: string;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
};

export type SourceSelectResponse = {
  data: SourceAppNamelist[];
};

export type SourceAppNamelist = {
  sourceId?: string;
  sourceApplicationName?: string;
  typeOfApplication?: number;
  secretKey?: number;
  createdOn?: string;
  createdBy?: string;
  successUrl?: string;
  failureUrl?: string;
  softCell?: boolean;
  active?: boolean;
  deleted?: boolean;
  paymentService?: boolean;
};

export type CallBackServiceListResponse = {
  data: SourceAppNamelist[];
};

export type CallBackServicelist = {
  displayName?: string;
  serviceName?: string;
  createdOn?: string;
  createdBy?: string;
};

export type ConfigNamelistResponse = {
  data: ConfigNamelist[];
};

export type ConfigNamelist = {
  name?: string;
  code?: string;
  configDesc?: string;
  valueDesc?: string;
  regEx?: string;
  errorMsg?: string;
  createdOn?: string;
  createdBy?: string;
  flag?: boolean;
};

export type ServiceNameListResponse = {
  data: ServiceNamelist[];
};

export type ServiceNamelist = {
  name?: string;
  code?: string;
  description?: string;
  createdOn?: string;
  createdBy?: string;
};

export type DedupeConfigPagedResponse = {
  data: DedupeConfigPagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type DedupeConfigPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: DedupeConfigPayload[];
  dedupeStartDate?: string;
  dedupeEndDate?: string;
};

export type DedupeConfigPayload = {
  trailId?: number;
  configBy?: string;
  dedupeStartDate?: string;
  dedupeEndDate?: string;
  configDate?: string;
};

export type CallBackConfigPagedResponse = {
  data: CallBackConfigPagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type CallBackConfigPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: CallBackConfigPayload[];
};

export type CallBackConfigPayload = {
  sourceId?: number;
  serviceName?: string;
  callbackURL?: string;
  headers?: string;
  flag?: boolean;
  createdBy?: string;
  createdOn?: string;
  sourceName?: string;
  displayName?: string;
  key?: string;
  value?: string;
};

export type AppLevelConfigPagedResponse = {
  data: AppLevelConfigPagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type AppLevelConfigPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: AppLevelConfigPayload[];
};

export type AppLevelConfigPayload = {
  sourceId?: string;
  configKey?: string;
  configValue?: string;
  sourceApplicationName?: string;
  flag?: boolean;
  createdBy?: string;
  createdOn?: string;
  configValueHours?: string;
  configValueMinutes?: string;
};

export type ServiceMappingConfigPagedResponse = {
  data: ServiceMappingConfigPagedList;
  message: string;
  responseCode: string;
  status: string;
};

export type ServiceMappingConfigPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: ServiceMappingConfigPayload[];
};

export type ServiceMappingConfigPayload = {
  sourceId?: string;
  serviceCode?: string;
  serviceValue?: string;
  sourceAppName?: string;
  flag?: boolean;
  createdBy?: string;
  createdOn?: string;
};

export type ModuleNameResponse = {
  data: ModuleNamelist[];
};

export type ModuleNamelist = {
  id?: number;
  name?: string;
  code?: string;
  description?: string;
  createdOn?: string;
  createdBy?: string;
};

export const getModuleMaster = (payload?: MstRequest) =>
  post<ModuleNameResponse>('/mastermodule/serviceMappingConfig/getModuleMaster', payload);

export const getSourceList = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/getSource', payload);

export const getSourceDownload = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/getSourceReport', payload);

export const addSourceList = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/Source/addSource', payload);

export const activateSource = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/Source/activateSource', payload);

export const updateSource = (payload?: updateSourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/Source/updateSource', payload);

export const deleteSource = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/Source/deleteSource', payload);

export const getSearchList = (payload?: SourcePayload) =>
  post<SourcePagedResponse>('/mastermodule/getSearchSource', payload);

export const getLoanTypeList = (payload?: DeleteLoanTypePayload) =>
  post<LoanTypePagedResponse>('/mastermodule/getLoanType', payload);

export const addLoanType = (payload?: AddLoanTypePayload) =>
  post<LoanTypePagedResponse>('/mastermodule/loan-type/addLoanType', payload);

export const deleteLoanType = (payload?: LoanTypePayload) =>
  post<LoanTypePagedResponse>('/mastermodule/loan-type/deleteLoanType', payload);

export const getUserList = (payload?: UserFilter) =>
  post<UserPagedResponse>('/mastermodule/getUsers', payload);

export const activateUser = (payload?: UserFilter) =>
  post<UserPagedResponse>('/mastermodule/User/activateUser', payload);

export const deleteUser = (payload?: UserFilter) =>
  post<UserPagedResponse>('/mastermodule/User/deleteUser', payload);

export const getFundAccountMapping = (payload?: FundAccountFilter) =>
  post<FundAccountPagedResponse>('/mastermodule/fundAccount/getFundAccountMapping', payload);

export const deleteFundAccountMapping = (payload?: FundAccountPayload) =>
  post<FundAccountPagedResponse>('/mastermodule/fundAccount/deleteFundAccountMapping', payload);

export const updateFundAccountMapping = (payload?: FundAccountUpdatePayload) =>
  post<FundAccountUpdatePagedResponse>(
    '/mastermodule/fundAccount/updateFundAccountMapping',
    payload
  );

export const createFundAccountMapping = (payload?: FundAccountUpdatePayload) =>
  post<FundAccountUpdatePagedResponse>(
    '/mastermodule/fundAccount/createFundAccountMapping',
    payload
  );

export const getMasterSettingsData = (payload?: SelectPayload) =>
  post<SelectResponse>('/mastermodule/getMasterSettingsData', payload);

export const getAllDedupeConfig = (payload?: MstRequest) =>
  post<DedupeConfigPagedResponse>('/mastermodule/dedupeConfig/getAllDedupeConfig', payload);

export const saveDedupeConfig = (payload?: DedupeConfigPayload) =>
  post<DedupeConfigPagedResponse>('/mastermodule/dedupeConfig/saveDedupeConfig', payload);

export const getDedupeConfig = (payload?: MstRequest) =>
  post<DedupeConfigPagedResponse>('/mastermodule/dedupeConfig/getDedupeConfig', payload);

export const getAllAppSourceConfig = (payload?: MstRequest) =>
  post<AppLevelConfigPagedResponse>('/mastermodule/appSourceConfig/getAllAppSourceConfig', payload);

export const saveAppSourceConfig = (payload?: AppLevelConfigPayload) =>
  post<AppLevelConfigPagedResponse>('/mastermodule/appSourceConfig/saveAppSourceConfig', payload);

export const getSourceAppNames = (payload?: MstRequest) =>
  post<SourceSelectResponse>('/mastermodule/getSourceAppNames', payload);

export const getMasterConfigDetails = (payload?: MstRequest) =>
  post<ConfigNamelistResponse>('/mastermodule/getMasterConfigDetails', payload);

export const getServiceSourceMappings = (payload?: MstRequest) =>
  post<ServiceMappingConfigPagedResponse>(
    '/mastermodule/serviceMappingConfig/getServiceSourceMappings',
    payload
  );

export const saveServiceMappingConfig = (payload?: AppLevelConfigPayload) =>
  post<ServiceMappingConfigPagedResponse>(
    '/mastermodule/serviceMappingConfig/saveServiceMappingConfig',
    payload
  );

export const getServiceName = (payload?: MstRequest) =>
  post<ServiceNameListResponse>('/mastermodule/serviceMappingConfig/getServiceName', payload);

export const getCallBackSourceServiceConfigs = (payload?: MstRequest) =>
  post<CallBackConfigPagedResponse>(
    '/mastermodule/callbackConfig/getCallBackSourceServiceConfigs',
    payload
  );

export const saveCallbackServiceSourceConfig = (payload?: CallBackConfigPayload) =>
  post<CallBackConfigPagedResponse>(
    '/mastermodule/callbackConfig/saveCallbackServiceSourceConfig',
    payload
  );

export const getCallBackServiceNames = (payload?: MstRequest) =>
  post<CallBackServiceListResponse>(
    '/mastermodule/callbackConfig/getCallBackServiceNames',
    payload
  );
